import TITLES from './titles';

export default {
  key: {
    default: 'default',
    serial: 'serial',
    name: 'name',
    order: 'order',
    status: 'status',
    paymentStatus: 'paymentStatus',
    paymentType: 'paymentType',
    transportcard: 'transportcard',
    profileId: 'profileId',
    profile: 'profile',
    period: 'period',
    tariff: 'tariff',
    type: 'type',
    lineModes: 'lineModes',
    lineModel: 'lineModel',
    carModel: 'carModel',
    profileStatus: 'profileStatus',
    document: 'document',
    email: 'email',
    supervisor: 'supervisor',
    createdAt: 'createdAt',
    profileExpiration: 'profileExpiration',
    cnpj: 'cnpj',
    nsu: 'nsu',
    phone: 'phone',
    license: 'license',
    prefix: 'prefix',
    model: 'model',
    footCapacity: 'footCapacity',
    sitCapacity: 'sitCapacity',
    ticketer: 'ticketer',
    accessible: 'accessible',
    airConditioned: 'airConditioned',
    age: 'age',
    registry: 'registry',
    licenseNumber: 'licenseNumber',
    number: 'number',
    cardNumber: 'cardNumber',
    cardType: 'cardType',
    lot: 'lot',
    title: 'title',
    covered: 'covered',
    busBay: 'busBay',
    blockName: 'blockName',
    specialBusStop: 'specialBusStop',
    responsible: 'responsible',
    terminalName: 'terminalName',
    totalLines: 'totalLines',
    validationStatus: 'validationStatus',
    user: 'user',
    day: 'day',
    score: 'score',
    facialStatus: 'facialStatus',
    approvalStatus: 'approvalStatus',
    numberOfDays: 'numberOfDays',
    balanceType: 'balanceType',
    cars: 'cars',
    kmType: 'kmType',
    line: 'line',
    lines: 'lines',
    schools: 'schools',
    employee: 'employee',
    driverRegistry: 'driverRegistry',
    collection: 'collection',
    creditType: 'creditType',
    dateType: 'dateType',
    dateTypeSales: 'dateTypeSales',
    dbd: 'dbd',
    filename: 'filename',
    payment: 'payment',
    qrCode: 'qrCode',
    lineType: 'lineType',
    receive: 'receive',
    receivingType: 'receivingType',
    seccionedLines: 'seccionedLines',
    sellingPoint: 'sellingPoint',
    sellingTerminal: 'sellingTerminal',
    tokenStatus: 'tokenStatus',
    usage: 'usage',
    usageType: 'usageType',
    voucher: 'voucher',
    voucherCollectionStatus: 'voucherCollectionStatus',
    voucherCollectionType: 'voucherCollectionType',
    weekDay: 'weekDay',
    incomingTypes: 'incomingTypes',
    device: 'device',
    terminal: 'terminal',
    emvType: 'emvType',
    invoicesListStatus: 'invoicesListStatus',
    brand: 'brand',
    emvStatus: 'emvStatus',
    schoolCode: '  schoolCode',
    schoolType: '  schoolType',
    statusDeviceRelease: 'statusDeviceRelease',
    creditCard: 'creditCard',
    tripStatus: 'tripStatus',
    tripOrTicket: 'tripOrTicket',
    companies: 'companies',
    bpeCode: 'bpeCode',
    bpeNumber: 'bpeNumber',
    origin: 'origin',
    destiny: 'destiny',
    lineSectionName: 'lineSectionName',
    benefit: 'benefit',
    paymentDay: 'paymentDay',
    includeBPe: 'includeBPe',
    operation: 'operation',
    dateTypeBPe: 'dateTypeBPe',
  },
  dbds: [
    { key: 'id', value: 'ID' },
    { key: 'serial', value: 'Serial' },
    { key: 'version', value: 'Versão' },
    { key: 'dbdPlace', value: 'Local' },
    { key: 'type', value: 'Tipo' },
    { key: 'spin', value: 'Giro' },
    { key: 'conectivityStatus', value: 'Conectividade' },
  ],
  profiles: [
    { key: 'name', value: 'Nome' },
    { key: 'order', value: 'Ordem' },
  ],
  benefits: [{ key: 'name', value: 'Nome' }],
  operation: [
    { key: 'day', value: 'Dia' },
    { key: 'operationType', value: 'Operação' },
  ],
  orders: [
    { key: 'status', value: 'Status' },
    { key: 'paymentStatus', value: 'Status do Pagamento' },
    { key: 'paymentType', value: 'Tipo do Pagamento' },
  ],
  passengers: [
    {
      key: 'name',
      value: 'Nome',
    },
    {
      key: 'transportcard',
      value: 'Cartão de Transporte',
    },
    {
      key: 'device',
      value: 'Dispositivo',
    },
    {
      key: 'profile',
      value: 'Perfil',
    },
    {
      key: 'profileStatus',
      value: 'Status do Perfil',
    },
    {
      key: 'document',
      value: 'Documento',
    },
    {
      key: 'email',
      value: 'Email',
    },
    {
      key: 'createdAt',
      value: 'Data de cadastro',
    },
    { key: 'period', value: 'Período' },
    {
      key: 'profileExpiration',
      value: 'Validade do Perfil',
    },
    {
      key: 'creditCard',
      value: 'Cartão de Crédito',
    },
  ],
  supervisor: [
    { key: 'name', value: 'Nome' },
    { key: 'email', value: 'Email' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  groups: [
    { key: 'name', value: 'Nome' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  ipAddress: [
    { key: 'name', value: 'Nome' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  company: [
    { key: 'name', value: 'Nome' },
    {
      key: 'cnpj',
      value: 'CNPJ',
    },
    {
      key: 'email',
      value: 'Email',
    },
    {
      key: 'phone',
      value: 'Telefone',
    },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  school: [
    { key: 'name', value: 'Nome' },
    {
      key: 'email',
      value: 'Email',
    },
    {
      key: 'document',
      value: 'CNPJ',
    },
    {
      key: 'phone',
      value: 'Telefone',
    },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  fleet: [
    { key: 'license', value: 'Placa' },
    { key: 'prefix', value: 'Prefixo' },
    { key: 'model', value: 'Modelo' },
    { key: 'footCapacity', value: 'Capacidade em pé' },
    { key: 'sitCapacity', value: 'Capacidade sentados' },
    { key: 'ticketer', value: 'Espaço para cobrador' },
    { key: 'accessible', value: 'Acessível' },
    { key: 'airConditioned', value: 'Climatizado' },
    { key: 'age', value: 'Idade do veículo' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],

  vessels: [
    { key: 'license', value: 'Placa' },
    { key: 'prefix', value: 'Prefixo' },
    { key: 'footCapacity', value: 'Capacidade passageiros' },
    { key: 'accessible', value: 'Acessível' },
    { key: 'airConditioned', value: 'Climatizado' },
    { key: 'age', value: 'Idade do veículo' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  drivers: [
    { key: 'name', value: 'Nome' },
    {
      key: 'phone',
      value: 'Telefone',
    },
    {
      key: 'document',
      value: 'Documento',
    },
    {
      key: 'registry',
      value: 'Matrícula',
    },
    {
      key: 'licenseNumber',
      value: 'Habilitação',
    },
    {
      key: 'profileStatus',
      value: 'Status',
    },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  ticketCollectors: [
    { key: 'name', value: 'Nome' },
    {
      key: 'phone',
      value: 'Telefone',
    },
    {
      key: 'document',
      value: 'Documento',
    },
    {
      key: 'registry',
      value: 'Matrícula',
    },
    {
      key: 'profileStatus',
      value: 'Status',
    },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  incharge: [
    { key: 'name', value: 'Nome' },
    {
      key: 'phone',
      value: 'Telefone',
    },
    {
      key: 'document',
      value: 'Documento',
    },
    {
      key: 'registry',
      value: 'Matrícula',
    },
    {
      key: 'profileStatus',
      value: 'Status',
    },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  transportCards: [
    { key: 'number', value: 'Número' },
    {
      key: 'cardNumber',
      value: 'Número Impresso',
    },
    {
      key: 'lot',
      value: 'Lote',
    },
    {
      key: 'cardType',
      value: 'Tipo de cartão',
    },
    {
      key: 'cardStatus',
      value: 'Status',
    },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  transportCardsPlace: [
    { key: 'name', value: 'Nome' },
    { key: 'responsible', value: 'Responsável' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  product: [
    { key: 'title', value: 'Título' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  line: [
    { key: 'name', value: 'Nome' },
    {
      key: 'status',
      value: 'Status',
    },
    {
      key: 'prefix',
      value: 'Prefixo',
    },
    {
      key: 'lineModes',
      value: 'Modo',
    },
    {
      key: 'lineModel',
      value: 'Perfil Tarifário',
    },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  itinerary: [
    { key: 'name', value: 'Nome' },
    {
      key: 'status',
      value: 'Status',
    },
    {
      key: 'prefix',
      value: 'Prefixo',
    },
    {
      key: 'lineModes',
      value: 'Modo',
    },
    {
      key: 'lineModel',
      value: 'Perfil Tarifário',
    },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  stop: [
    { key: 'name', value: 'Nome' },
    { key: 'covered', value: 'Coberto' },
    { key: 'busBay', value: 'Baia' },
    { key: 'specialBusStop', value: 'Ponto Especial' },
    { key: 'createdAt', value: 'Data de cadastro' },
    { key: 'line', value: 'Linhas' },
  ],
  section: [
    { key: 'name', value: 'Nome' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  garageManagement: [
    { key: 'name', value: 'Nome' },
    { key: 'cnpj', value: 'CNPJ' },
    { key: 'phone', value: 'Telefone' },
    { key: 'responsible', value: 'Responsável' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  terminalManagement: [
    { key: 'name', value: 'Nome' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  terminalBlocks: [
    { key: 'name', value: 'Nome' },
    { key: 'terminalName', value: 'Terminal' },
    { key: 'totalLines', value: 'Linhas' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  pedestriansByTerminal: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'terminal', value: 'Terminais' },
  ],
  tolls: [
    { key: 'name', value: 'Pedágio' },
    { key: 'tariff', value: 'Tarifa' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  sellingTerminals: [
    { key: 'name', value: 'Nome' },
    { key: 'createdAt', value: 'Data de cadastro' },
    { key: 'document', value: 'Documento' },
  ],
  sellingTerminalRealTimeCashier: [
    { key: 'sellingPointName', value: 'Ponto de venda' },
    { key: 'totalValue', value: 'Valor em caixa' },
  ],
  transportVouchers: [
    { key: 'name', value: 'Nome' },
    { key: 'createdAt', value: 'Data de cadastro' },
  ],
  // Facial Recognition
  sendFiles: [
    { key: 'dbd', value: 'DBD' },
    { key: 'line', value: 'Linha' },
    { key: 'place', value: 'Prefixo do carro' },
  ],
  // Tunrstiles
  Tunrstiles: [{ key: 'numberOfDays', value: 'Período' }],
  tripInfo: [
    { key: 'prefix', value: 'Prefixo do carro' },
    { key: 'line', value: 'Linha' },
    { key: 'employee', value: 'Motorista' },
  ],
  tripInfoRemote: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'employee', value: 'Motorista' },
    {
      key: 'driverRegistry',
      value: 'Matrícula do Motorista',
    },
  ],
  // Synoptic
  synoptic: [{ key: 'line', value: 'Linha' }],
  // Validations
  registrationValidation: [
    { key: 'period', value: 'Período' },
    { key: 'validationStatus', value: 'Status' },
    { key: 'user', value: 'Usuários' },
  ],
  facialRecognition: [
    { key: 'period', value: 'Período' },
    { key: 'day', value: 'Dia' },
    { key: 'score', value: 'Score' },
    { key: 'facialStatus', value: 'Facial Status' },
    { key: 'approvalStatus', value: 'Status de Aprovação' },
    { key: 'supervisor', value: 'Supervisores' },
    { key: 'employee', value: 'Motorista' },
    { key: 'lines', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
    { key: 'user', value: 'Usuários' },
  ],
  boardingInspection: [
    { key: 'period', value: 'Período' },
    { key: 'approvalStatus', value: 'Status de Aprovação' },
    { key: 'supervisor', value: 'Supervisores' },
    { key: 'employee', value: 'Motorista' },
    { key: 'lines', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
  ],
  boardingInspectionHistory: [
    { key: 'numberOfDays', value: 'Período' },
    { key: 'supervisor', value: 'Supervisores' },
    { key: 'employee', value: 'Motorista' },
    { key: 'lines', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
  ],
  deviceRelease: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'user', value: 'Usuários' },
    { key: 'statusDeviceRelease', value: 'Status' },
  ],
  // Integrations
  integration: [{ key: 'line', value: 'Linha' }],
  // Selling Terminals
  sellingTerminal: [{ key: 'numberOfDays', value: 'Período' }],
  sellingTerminalDay: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'sellingTerminal', value: 'Rede de venda' },
  ],
  sellingPOintShiftSchedule: [
    { key: 'day', value: 'Dia' },
  ],
  // Onboard Sales
  onboardSales: [{ key: 'numberOfDays', value: 'Período' }],
  // Live Monitoring
  synopticTab: [{ key: 'period', value: 'Período' }],
  mapTab: [
    { key: 'lines', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
  ],

  // Conectivity
  conectivityCover: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    { key: 'dbd', value: 'DBD' },
  ],

  // Trip Monitoring
  tripMapTab: [
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
  ],
  tripFiscalizationTab: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'employee', value: 'Motorista' },
    { key: 'line', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
  ],
  // Reports
  entry: [
    { key: 'line', value: 'Linha' },
    { key: 'dbd', value: 'DBD' },
    { key: 'benefit', value: 'Beneficio' },
    { key: 'createdAt', value: 'Data de cadastro' },
    { key: 'value', value: 'Value' },
    { key: 'description', value: 'Descrição' },
    { key: 'usedDate', value: 'Data Agrupado' },
    { key: 'paymentType', value: 'Forma de Recebimento' },
    { key: 'qrCode', value: 'Tipo do QRCode' },
  ],
  entryRemote: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    { key: 'emvType', value: 'Tipo da Transação' },
    { key: 'cars', value: `${TITLES.carTitle}` },
    { key: 'employee', value: 'Motorista' },
    {
      key: 'profile',
      value: 'Perfil',
    },
    { key: 'payment', value: 'Forma de Embarque' },
    { key: 'qrCode', value: 'Tipo do QRCode' },
    { key: 'terminal', value: 'Terminais' },
  ],
  // field filter
  transportedPassagersRemote: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'payment', value: 'Forma de Embarque' },
    { key: 'line', value: 'Linhas' },
    { key: 'dbd', value: 'DBD' },
    {
      key: 'profile',
      value: 'Perfil',
    },
    { key: 'cars', value: `${TITLES.carTitle}` },
    { key: 'employee', value: 'Motorista' },
  ],

  // local filter
  transportedPassagersLocal: [
    { key: 'JAN', value: 'JAN' },
    { key: 'FEV', value: 'FEV' },
    { key: 'MAR', value: 'MAR' },
    { key: 'ABR', value: 'ABR' },
    { key: 'MAI', value: 'MAI' },
    { key: 'JUN', value: 'JUN' },
    { key: 'JUL', value: 'JUL' },
    { key: 'AGO', value: 'AGO' },
    { key: 'SET', value: 'SET' },
    { key: 'OUT', value: 'OUT' },
    { key: 'NOV', value: 'NOV' },
    { key: 'DEZ', value: 'DEZ' },
  ],

  // field filter
  kmDrivedListRemote: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    { key: 'dbd', value: 'DBD' },
    { key: 'cars', value: `${TITLES.carTitle}` },
    { key: 'employee', value: 'Motorista' },
  ],

  chartValue: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    {
      key: 'profile',
      value: 'Perfil',
    },
    { key: 'payment', value: 'Forma de pagamento' },
  ],
  shipmentDistribution: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    {
      key: 'profile',
      value: 'Perfil',
    },
    { key: 'payment', value: 'Forma de pagamento' },
    { key: 'line', value: 'Linhas' },
  ],
  shipmentByLine: [
    { key: 'period', value: 'Período' },
    {
      key: 'profile',
      value: 'Perfil',
    },
    { key: 'cars', value: `${TITLES.carTitle}` },
  ],
  superiorUsage: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    {
      key: 'profile',
      value: 'Perfil',
    },
    { key: 'usage', value: 'Quantidade de uso' },
    { key: 'payment', value: 'Forma de Embarque' },
  ],
  receipts: [
    { key: 'value', value: 'Valor' },
    { key: 'type', value: 'Tipo' },
    { key: 'from', value: 'De' },
    { key: 'to', value: 'para' },
    { key: 'value', value: 'Valor' },
    { key: 'date', value: 'Data' },
  ],
  receiptsRemote: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'supervisor', value: 'Supervisores' },
  ],
  // Onboard Sales
  paymentTabRemote: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'employee', value: 'Motorista' },
    { key: 'dateTypeSales', value: 'Tipo de Data' },
  ],
  transactionsTabRemote: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'employee', value: 'Motorista' },
    { key: 'dateTypeSales', value: 'Tipo de Data' },
    { key: 'paymentType', value: 'Forma de Recebimento' },
    { key: 'qrCode', value: 'Tipo do QRCode' },
    { key: 'lineType', value: 'Tipo de Linha' },
  ],
  // Collection
  collection: {
    paymentTabRemote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      { key: 'sellingPoint', value: 'Ponto de venda' },
      { key: 'sellingTerminal', value: 'Rede de venda' },
    ],
    transactionsTabRemote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      { key: 'sellingPoint', value: 'Ponto de venda' },
      { key: 'sellingTerminal', value: 'Rede de venda' },
      { key: 'creditType', value: 'Tipo de Crédito' },
      { key: 'paymentType', value: 'Forma de Recebimento' },
      { key: 'qrCode', value: 'Tipo do QRCode' },
    ],
  },
  // Modal selling Points
  modal: {
    paymentTabModal: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
    ],
    transactionsTabModal: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
    ],
  },

  // Transport Voucher Collection
  transportVoucherCollection: {
    transactionsTabRemote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      { key: 'dateType', value: 'Tipo de Data' },
      { key: 'voucherCollectionType', value: 'Tipo de Pedido' },
      { key: 'voucherCollectionStatus', value: 'Status do Voucher' },
      { key: 'paymentType', value: 'Forma de Recebimento' },
    ],
  },
  // Education Instituin Collection
  EducationInstituinCollection: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'voucherCollectionStatus', value: 'Status' },
    { key: 'nsu', value: 'Nsu' },
    { key: 'paymentType', value: 'Forma de Recebimento' },
    { key: 'paymentDay', value: 'Data do Pagamento' },
    { key: 'companies', value: 'Empresas' },
  ],
  // Incoming By Km ValueReport
  incomingByKmValue: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'incomingTypes', value: 'Relatorio de Arrecadação' },
  ],

  // Payment Request
  paymentRequenst: {
    remote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      { key: 'paymentType', value: 'Forma de Recebimento' },
      { key: 'sellingTerminal', value: 'Rede de venda' },
      { key: 'paymentStatus', value: 'Status' },
    ],
  },
  // Importations
  importations: {
    remote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      // { key: 'filename', value: 'Nome do arquivo' },
    ],
  },
  // Company Acquisitions
  companyAcquisitions: {
    remote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      { key: 'lines', value: 'Linhas' },
    ],
    shopping: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      { key: 'companies', value: 'Empresas' },
    ],
  },
  // Passengers by timeframe
  passengersByTimeframe: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'payment', value: 'Forma de Embarque' },
    { key: 'lines', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
  ],
  // Emtu
  emtu: {
    remote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
    ],
  },
  // Line Demand
  lineDemand: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    { key: 'seccionedLines', value: 'Filtro por Trecho' },
  ],
  // Km per Day
  kmPerDay: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
  ],
  // Passengers by Origin
  passengersByOrigin: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'cars', value: `${TITLES.carTitle}` },
    { key: 'employee', value: 'Motorista' },
    { key: 'line', value: 'Linhas' },
  ],
  transactionsResume: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
  ],
  // Emv
  emv: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
    { key: 'brand', value: 'Bandeiras' },
    { key: 'emvType', value: 'Tipo da Transação' },
    { key: 'emvStatus', value: 'Status' },
    { key: 'nsu', value: 'Nsu' },
  ],

  // Bpe
  bpe: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'dateTypeBPe', value: 'Tipo de Data' },
    { key: 'name', value: 'Nome' },
    { key: 'document', value: 'CPF' },
    { key: 'license', value: 'Placa' },
    { key: 'prefix', value: 'prefix' },
    { key: 'benefit', value: 'Beneficio' },
    { key: 'employee', value: 'Motorista' },
    { key: 'lineSectionName', value: 'Nome do Trecho' },
    { key: 'bpeNumber', value: 'Numero BPE' },
    { key: 'bpeCode', value: 'Codigo BPE' },
    { key: 'origin', value: 'Origem' },
    { key: 'destiny', value: `Destino` },
    { key: 'includeBPe', value: `Presença de BPE` },
  ],
  // Bpe Tax Verification
  bpeTaxVerification: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'dateTypeBPe', value: 'Tipo de Data' },
    { key: 'bpeNumber', value: 'Numero BPE' },
    { key: 'bpeCode', value: 'Codigo BPE' },
  ],

  // Gratuities
  Gratuities: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'benefit', value: 'Beneficio' },
  ],

  // School Order Report
  schoolOrder: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'schools', value: 'Escola' },
    { key: 'voucherCollectionStatus', value: 'Status do Voucher' },
  ],
  // Student Device Report
  studentDevice: [
    { key: 'period', value: 'Período' },
    { key: 'schools', value: 'Escola' },
  ],
  // Segment Demand
  segmentDemand: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    { key: 'tripOrTicket', value: 'Horário da Viagem/Passagem' },
  ],
  // Car Demand
  carDemand: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
  ],
  // Company Boarding History Tab
  boardingHistoryTab: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'license', value: 'Placa' },
  ],
  halfTripDiary: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'line', value: 'Linhas' },
    { key: 'cars', value: `${TITLES.carTitle}` },
    { key: 'employee', value: 'Motorista' },
    { key: 'kmType', value: 'Tipo de Quilometragem' },
  ],
  // Credit By School
  creditBySchool: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'schoolCode', value: 'Código' },
    { key: 'schoolType', value: 'Tipo' },
  ],

  // OperatorCommission
  operatorCommission: {
    remote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      { key: 'employee', value: 'Motorista' },
      {
        key: 'profile',
        value: 'Perfil',
      },
      { key: 'payment', value: 'Forma de pagamento' },
      { key: 'collection', value: 'Arrecadação' },
    ],
  },
  // General
  general: {
    remote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      { key: 'lines', value: 'Linhas' },
    ],
  },
  // Travel By Line
  travelByLine: {
    remote: [
      { key: 'day', value: 'Dia' },
      { key: 'period', value: 'Período' },
      { key: 'line', value: 'Linhas' },
      { key: 'seccionedLines', value: 'Filtro por Trecho' },
    ],
  },
  // Employee Trip Resume
  employeeTripResume: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'employee', value: 'Motorista' },
    { key: 'tripStatus', value: 'Status da Viagem' },
  ],
  // Relations
  notifications: {
    remote: [{ key: 'day', value: 'Dia' }],
  },
  segmentations: {
    remote: [{ key: 'day', value: 'Dia' }],
  },
  fareBonus: [
    { key: 'name', value: 'Nome' },
    { key: 'status', value: 'Status' },
  ],
  fareTax: [{ key: 'name', value: 'Nome' }],
  invoicesList: [
    { key: 'day', value: 'Dia' },
    { key: 'invoicesListStatus', value: 'Status' },
  ],

  // Report Onboard Sales
  ReportOnboardSales: [
    { key: 'amount', value: 'Valor' },
    { key: 'createdAt', value: 'Data' },
    { key: 'description', value: 'Descrição' },
    { key: 'id', value: 'código transação' },
    { key: 'usedDate', value: 'Agrupado por data' },
    { key: 'totalValue', value: 'Agrupado por total' },
  ],

  // Report Transport Voucher Collection
  ReportTransportVoucherCollection: [
    { key: 'createdAt', value: 'Data' },
    { key: 'name', value: 'Nome' },
    { key: 'document', value: 'Documento' },
    { key: 'id', value: 'código transação' },
    { key: 'nsu', value: 'Nsu' },
    { key: 'value', value: 'Valor' },
  ],

  // Report Importation
  ReportImportation: [
    { key: 'company', value: 'Empresa' },
    { key: 'createdAt', value: 'Data' },
    { key: 'fileName', value: 'Nome do Arquivo' },
    { key: 'nsu', value: 'Nsu' },
  ],
  // Report Emtu
  ReportEmtu: [{ key: 'user', value: 'Nome Usuário' }],

  // Report Payment Request
  ReportPaymentRequest: [
    { key: 'createdAt', value: 'Data' },
    { key: 'id', value: 'id' },
    { key: 'name', value: 'Nome' },
    { key: 'value', value: 'Valor' },
  ],

  // Report Half Trip
  ReportHalfTrip: [
    { key: 'id', value: 'Viagem' },
    { key: 'startedAt', value: 'Data' },
    { key: 'name', value: 'Nome' },
  ],

  // Report Travel By Line
  ReportTravelByLine: [
    { key: 'name', value: 'Nome' },
    { key: 'prefix', value: 'prefix' },
  ],

  // Taxes
  taxes: [
    { key: 'id', value: 'ID' },
    { key: 'name', value: 'Nome' },
  ],
  taxesByCompany: [
    { key: 'id', value: 'ID' },
    { key: 'name', value: 'Nome' },
    { key: 'cnpj', value: 'CNPJ' },
    { key: 'phone', value: 'Phone' },
    { key: 'email', value: 'Email' },
  ],
  // Usage Statistics
  usageStatistics: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    {
      key: 'profile',
      value: 'Perfil',
    },
  ],
  usageStatisticsLocal: [
    { key: 'range', value: '% Utilização' },
    { key: 'quantity', value: 'Qtd. Cartões' },
    { key: 'percentage', value: '%Cartões' },
  ],
  // Report Profile By Age Groupe
  ReportProfileByAgeGroupe: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    {
      key: 'profile',
      value: 'Perfil',
    },
  ],

  // Profile Line
  ProfileLine: [
    { key: 'name', value: 'Nome' },
    { key: 'prefix', value: 'Prefix' },
    { key: 'status', value: 'Status' },
  ],

  // Only period
  OnlyPeriod: [{ key: 'period', value: 'Período' }],
  // Only day
  OnlyDay: [{ key: 'day', value: 'Dia' }],
  // period and day
  PeriodAndDay: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
  ],
  TripSchedules: [
    { key: 'start', value: 'Data/Hora Início' },
    { key: 'lineName', value: 'Linha (Nome)' },
    { key: 'linePrefix', value: 'Linha (Prefixo)' },
    { key: 'car', value: 'Veículo (Programado)' },
    { key: 'tripCar', value: 'Veículo (Realizado)' },
    { key: 'employee', value: 'Motorista (Programado)' },
    { key: 'tripEmployee', value: 'Motorista (Realizado)' },
    { key: 'service', value: 'Serviço' },
    { key: 'way', value: 'Sentido' },
  ],
  monitoringFiscalization: [
    { key: 'day', value: 'Dia' },
    { key: 'lines', value: 'Linhas' },
  ],
  fiscalization: [
    {
      key: 'lineName',
      value: 'Nome',
    },
  ],

  // Import xml
  importXml: [
    { key: 'name', value: 'Nome' },
    { key: 'cpf', value: 'CPF' },
    { key: 'status', value: 'Status' },
  ],

  employeeTRipSapResume: [
    { key: 'day', value: 'Dia' },
    { key: 'period', value: 'Período' },
    { key: 'employee', value: 'Motorista' },
  ],
};
